body {
  margin: 0;
  font-family: system-ui, sans-serif;
  background: #f3f4f6;
  color: #111827;
}
